//
export enum EventConstraints {
  HIDE_APP_LOADER = "HIDE_APP_LOADER",
  SHOW_APP_LOADER = "SHOW_APP_LOADER",
  TOGGLE_LEFT_SIDE_NAV = "TOGGLE_LEFT_SIDE_NAV",
  TOGGLE_APP_DRAWER = "TOGGLE_APP_DRAWER",
  UPDATE_CUSTOMER_LIST = "UPDATE_CUSTOMER_LIST",
  ORDERS_TYPE_VIEW = "ORDERS_TYPE_VIEW",
  TOGGLE_EDIT_CUSTOMER_PAGE = "TOGGLE_EDIT_CUSTOMER_PAGE",
  TOGGLE_PREVIEW_CUSTOMER_PAGE = "TOGGLE_PREVIEW_CUSTOMER_PAGE",
  DRIVERS_OPEN_CREATE = "DRIVERS_OPEN_CREATE",
  DRIVERS_OPEN_EDIT = "DRIVERS_OPEN_EDIT",
  DELETE_DRIVER = "DELETE_DRIVER",
  CLOSE_DRIVER_EDIT = "CLOSE_DRIVER_EDIT",
  CREATE_ORDER_OPEN_CATEGORY_DETAILS = "CREATE_ORDER_OPEN_CATEGORY_DETAILS",
  CREATE_ORDER_OPEN_ITEM_DETAILS = "CREATE_ORDER_OPEN_ITEM_DETAILS",
  CREATE_ORDER_OPEN_CONFIRM_ORDER = "CREATE_ORDER_OPEN_CONFIRM_ORDER",
  CREATE_ORDER_PACKAGE_SET_STEP = "CREATE_ORDER_PACKAGE_SET_STEP",
  CREATE_ORDER_FILTER_ITEMS_BY_CATEGORY = "CREATE_ORDER_FILTER_ITEMS_BY_CATEGORY",
  CREATE_ORDER_CUSTOMER_SET_EDIT_CUSTOMER = "CREATE_ORDER_CUSTOMER_SET_EDIT_CUSTOMER",
  CALL_CENTER_TOGGLE_CUSTOMER_DRAWER = "CALL_CENTER_TOGGLE_CUSTOMER_DRAWER",
  CREATE_ORDER_RESET_MENU = "CREATE_ORDER_RESET_MENU",
  CREATE_ORDER_CHECK_DISCOUNT = "CREATE_ORDER_CHECK_DISCOUNT",
  CREATE_ORDER_OPEN_CUSTOMER_INSIGHTS = "CREATE_ORDER_OPEN_CUSTOMER_INSIGHTS",
  CREATE_ORDER_SET_CUSTOMER_DRAWER_STEP = "CREATE_ORDER_SET_CUSTOMER_DRAWER_STEP",
  CREATE_ORDER_SHOW_FULL_LOADER = "CREATE_ORDER_SHOW_FULL_LOADER",
  CREATE_ORDER_UPDATE_ORDER = "CREATE_ORDER_UPDATE_ORDER",
  CREATE_ORDER_SET_CUSTOMER_FAV = "CREATE_ORDER_SET_CUSTOMER_FAV",
  CALL_CENTER_CHANGE_LOCATION = "CALL_CENTER_CHANGE_LOCATION",
  CALL_CENTER_SETUP_COLLECTION_EXPAND = "CALL_CENTER_SETUP_COLLECTION_EXPAND",
  CALL_CENTER_UPDATE_DISCOUNT_VALUE = "CALL_CENTER_UPDATE_DISCOUNT_VALUE",
  CREATE_ORDER_CUSTOMER_TAG_DISCOUNT = "CREATE_ORDER_CUSTOMER_TAG_DISCOUNT",
  CREATE_ORDER_OPEN_CONFIG_CUSTOMER = "CREATE_ORDER_OPEN_CONFIG_CUSTOMER",
  ORDERS_REFRESH_LIST = "ORDERS_REFRESH_LIST",
  DELETE_TAX = "DELETE_TAX",
  CREATE_ORDER_UPDATE_ORDER_OPTION = "CREATE_ORDER_UPDATE_ORDER_OPTION",
  REFRESH_SALES_OPTIONS = "REFRESH_SALES_OPTIONS",
  SALE_OPTION_OPEN_EDIT = "SALE_OPTION_OPEN_EDIT",
  DELETE_SALE_OPTION = "DELETE_SALE_OPTION",
  CLOSE_SALE_OPTION_EDIT = "CLOSE_SALE_OPTION_EDIT",
  // Call Center Order Card
  REMOVE_ORDER = "REMOVE_ORDER",
  RE_PENDING_ORDER = "RE_PENDING_ORDER",
  OPEN_ORDER_DETAILS = "OPEN_ORDER_DETAILS",
  OPEN_ORDER_TRANSACTION_DETAILS = "OPEN_ORDER_TRANSACTION_DETAILS",
  CLOSE_TAB_DRAWER = "CLOSE_TAB_DRAWER",
  OPEN_CUSTOM_ITEM_MODAL = "OPEN_CUSTOM_ITEM_MODAL",

  UPLOAD_IMAGE_EVENT = "UPLOAD_IMAGE_EVENT",
  EDIT_IMAGE_EVENT = "EDIT_IMAGE_EVENT",
  UPDATE_EXTRA_CHARGES_LIST = "UPDATE_EXTRA_CHARGES_LIST",
  UPDATE_DISCOUNTS_LIST = "UPDATE_DISCOUNTS_LIST",

  //Extra charges
  CLOSE_APP_DRAWER = "CLOSE_APP_DRAWER",
  CLOSE_DRAWER_NO_CONFIRMATION = "CLOSE_DRAWER_NO_CONFIRMATION",
  UPDATE_IMAGE_SOURCE = "UPDATE_IMAGE_SOURCE",

  OPEN_DISCOUNT_DETAILES = "OPEN_DISCOUNT_DETAILES",
  SUBMIT_CALCULATE_TAB = "SUBMIT_CALCULATE_TAB",

  ACCOUNTS_TOGGLE_AVAILABLE_BRANCHES = "ACCOUNTS_TOGGLE_AVAILABLE_BRANCHES",
  ACCOUNTS_TOGGLE_DEFAULT_BRANCH = "ACCOUNTS_TOGGLE_DEFAULT_BRANCH",

  //OOC
  MENU_NAME = "MENU_NAME",
  CREATE_MENU_OOC = "CREATE_MENU_OOC",
  ADD_ON_ENTER = "ADD_ON_ENTER",
  TOGGLE_ADD_MENU_MODAL = "TOGGLE_ADD_MENU_MODAL",
  TOGGLE_EDIT_MERCHANT_MODEL = "TOGGLE_EDIT_MERCHANT_MODEL",
  REFRESH_MENUS_PAGE = "REFRESH_MENUS_PAGE",
  TOGGLE_EDIT_MENU_MODAL = "TOGGLE_EDIT_MENU_MODAL",
  REFRESH_INTEGRATION_LIST = "REFRESH_INTEGRATION_LIST",

  UPDATE_TAXES_LIST = "UPDATE_TAXES_LIST",
  CLOSE_BUSINESS_EDIT = "CLOSE_BUSINESS_EDIT",

  //Filter
  UPDATE_QUERY_PARAMETERS = "UPDATE_QUERY_PARAMETERS",
  CLEAR_SPECIAL_COLUMN = "CLEAR_SPECIAL_COLUMN",
  LOCATION_DETAILS_CHANGE_STEP = "LOCATION_DETAILS_CHANGE_STEP",

  UPDATE_EXCHANGES_LIST = "UPDATE_EXCHANGES_LIST",
  DELETE_EXCHANGE = "DELETE_EXCHANGE",
  EXCHANGE_OPEN_EDIT = "EXCHANGE_OPEN_EDIT",

  CLOSE_PAYMENT_CATEGORY_EDIT = "CLOSE_PAYMENT_CATEGORY_EDIT",
  DIGITAL_MENU_INI_ORIGINAL_FORM = "DIGITAL_MENU_INI_ORIGINAL_FORM",
}
